module.exports = __webpack_public_path__ + "static/img/areaA_4.ecd8754.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/areaA_4.png
// module id = 1076
// module chunks = 1